import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import noop from 'lodash/noop';
import { BlockLink, LinkProps, Flex, Text, Icon } from 'roo-ui/components';
import { Link as RouterLink } from 'react-router-dom';

interface ItemLinkProps extends Partial<LinkProps> {
  label: string;
  url: string;
  onClick: any;
  external?: boolean;
}

const Link = styled(BlockLink)`
  margin-bottom: ${themeGet('space.4')};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const ItemLink = ({ label, url, external, ...props }: ItemLinkProps) => {
  return (
    <Link as={external ? 'a' : RouterLink} to={url} href={url} {...props}>
      <Flex justifyContent="space-between" fontSize="lg">
        <Text fontSize="lg">{label}</Text>
        <Icon name="arrowForward" color="red" />
      </Flex>
    </Link>
  );
};

ItemLink.defaultProps = {
  onClick: noop,
};

ItemLink.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default ItemLink;
